import { Log, ReportReasonsIds } from '@/types/logs'
import { OfficialReportType } from '@/types/officialReport'

export const getOfficialReportTypeByCode = (log: Log): OfficialReportType => {
    if (!log.codeTypeReasonInfo?.reasonId) {
        return OfficialReportType.Generic
    }

    if (ReportReasonsIds.LateTakeover.includes(log.codeTypeReasonInfo.reasonId)) {
        return OfficialReportType.LateTakeover
    }

    if (ReportReasonsIds.LateDeparture.includes(log.codeTypeReasonInfo.reasonId)) {
        return OfficialReportType.LateDeparture
    }

    if (ReportReasonsIds.Headway.includes(log.codeTypeReasonInfo.reasonId)) {
        return OfficialReportType.Headway
    }

    return OfficialReportType.Generic
}
